// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"159":"4da5b787","610":"3877ce84"}[chunkId] + ".chunk.css";
};